import type { ComponentPropsWithRef, ReactNode } from "react";
import { Fragment, forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesSecondaryBlockDefaultStyles } from "../constants";

export interface SalesBlock5Props extends ComponentPropsWithRef<"div"> {
  cards: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const SalesBlock5 = forwardRef<HTMLDivElement, SalesBlock5Props>(
  ({ header, cards, footer, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesSecondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-primary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-divide-primary wb-flex wb-flex-col wb-divide-y md:wb-grid md:wb-grid-cols-2 md:wb-divide-x md:wb-divide-y-0 lg:wb-grid-cols-4">
                {cards}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock
                as={Fragment}
                block={footer}
                render={footer => (
                  <div className="wb-mx-auto wb-flex wb-flex-col wb-justify-center wb-gap-10 wb-items-center">
                    <div className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                      {footer}
                    </div>
                  </div>
                )}
              />
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock5.displayName = "SalesBlock5";
